import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import authRequests from './auth/authRequest'
import Site from '../constants/site'

const replaceCdnHost = (value: unknown): unknown => {
	if (typeof value === 'string') {
		return value.split(Site.prodS3Domain).join(Site.proxyS3Domain)
	}

	if (Array.isArray(value)) {
		return value.map(replaceCdnHost)
	}

	if (
		value &&
		typeof value === 'object' &&
		Object.getPrototypeOf(value) === Object.prototype
	) {
		return Object.fromEntries(
			Object.entries(value).map(([key, nestedValue]) => [
				key,
				replaceCdnHost(nestedValue),
			])
		)
	}

	return value
}

const responseCdnInterceptor = (response: AxiosResponse) => {
	const isCdnProxyDomain =
		location.hostname === Site.proxyRootDomain ||
		location.hostname.endsWith(`.${Site.proxyRootDomain}`)

	if (Site.alwaysUseProxyS3Domain || isCdnProxyDomain) {
		response.data = replaceCdnHost(response.data)
	}

	return response
}

const $api = axios.create({
	withCredentials: false,
	baseURL: Site.protocol + Site.rootDomain,
	// baseURL: 'https://credu.ai',
})

$api.interceptors.request.use((config: AxiosRequestConfig) => {
	config.headers!.Authorization = `Bearer ${localStorage.getItem('token')}`
	return config
})

const responseAuthInterceptor = async (error: AxiosError) => {
	if (
		error.response?.status === 401 &&
		error.config &&
		!error.config._isRetry
	) {
		const originalRequest = error.config
		originalRequest._isRetry = true

		const response = await authRequests.refresh()

		window.localStorage.setItem('token', response.data.accessToken)
		return $api.request(originalRequest)
	}

	throw error
}

$api.interceptors.response.use(responseCdnInterceptor, responseAuthInterceptor)

export default $api
